import { useRecoilValue } from "recoil";
import { Box } from "@mui/joy";
import React, { useEffect, useRef } from "react";
import { layoutAtom } from "recoil/layoutAtom";
import { useMediaQuery, useTheme } from "@mui/material";
import useBottomSafePadding from "hooks/useBottomSafePadding";

export default function ContentTemplateV2({
  children,
  fullBleed,
  disableBottomSafeArea,
  isWide,
  setContainerHeight,
  containerId,
  backgroundColor,
}: {
  children: React.ReactNode;
  /** 좌우(`px-20`) · 상단(`pt-8`) 패딩 제거. child 가 풀-블리드 레이아웃을 직접 제어할 때 사용. */
  fullBleed?: boolean;
  /** 하단 safe-area(env(safe-area-inset-bottom)) 패딩 제거. floating CTA 가 자체 처리하거나 풀스크린 child 가 home indicator 까지 닿아야 할 때 사용. */
  disableBottomSafeArea?: boolean;
  isWide?: boolean;
  setContainerHeight?: React.Dispatch<React.SetStateAction<number>>;
  containerId?: string;
  backgroundColor?: string;
}) {
  const { taskWidth } = useRecoilValue(layoutAtom);
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const containerRef = useRef<HTMLDivElement>(null);
  // 마지막 inline 추가 콘텐츠 (예: NotificationSettingsUpdatePage 의 "알림 제거"
  // 버튼) 이 home indicator 에 바짝 붙지 않도록 안전영역 pb 제공.
  // iOS 는 env(34), Android in-app 은 16px, 그 외는 0 (기존 동작).
  const safePb = useBottomSafePadding("0px");

  useEffect(() => {
    setTimeout(() => {
      if (setContainerHeight && containerRef.current?.offsetHeight) {
        setContainerHeight(containerRef.current?.offsetHeight);
      }
    }, 100);
  }, [containerRef.current]);

  return (
    <div
      ref={containerRef}
      id={containerId}
      className={`h-full w-full overflow-y-auto ${
        !fullBleed && "pt-[8px] px-[20px]"
      }  overflow-x-hidden scrollbar-hide`}
      style={{
        ...(backgroundColor && { backgroundColor: backgroundColor }),
        overscrollBehavior: "none",
        WebkitOverflowScrolling: "auto", // 기본값은 'touch'로 iOS에서 바운스 발생
        ...(disableBottomSafeArea ? {} : { paddingBottom: safePb }),
      }}
    >
      <Box
        className={`relative w-full  ${
          taskWidth === "normal" && `${!isWide && "max-w-[660px] mx-auto"}`
        }`}
      >
        {children}
      </Box>
    </div>
  );
}
